import React from 'react';
import styled from 'styled-components';

/**
 * Props for the Spinner component.
 */
interface SpinnerProps {
  size?: number | 'sm' | 'md' | 'lg';
  color?: string;
}

/**
 * Spinner component.
 * Displays a loading spinner with customizable size and color.
 */
const Spinner: React.FC<SpinnerProps> = ({ size = 'md', color }) => {
  // Convert size to pixels if it's a string
  let sizeInPx: number;
  if (typeof size === 'number') {
    sizeInPx = size;
  } else {
    switch (size) {
      case 'sm':
        sizeInPx = 16;
        break;
      case 'lg':
        sizeInPx = 32;
        break;
      case 'md':
      default:
        sizeInPx = 24;
        break;
    }
  }

  return (
    <SpinnerContainer size={sizeInPx} color={color}>
      <div className="spinner"></div>
    </SpinnerContainer>
  );
};

/**
 * Styled container for the spinner.
 */
interface SpinnerContainerProps {
  size: number;
  color?: string;
}

const SpinnerContainer = styled.div<SpinnerContainerProps>`
  display: inline-block;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  
  .spinner {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: ${props => Math.max(2, props.size / 8)}px solid rgba(0, 0, 0, 0.1);
    border-top-color: ${props => props.color || props.theme.colors.primary};
    animation: spin 1s infinite linear;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Spinner; 